'use client'
import React from 'react'

export const UnorderedListIcon: React.FC = () => (
  <svg
    aria-hidden="true"
    className="icon"
    fill="none"
    focusable="false"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="4" cy="5" fill="currentColor" r="1.15" stroke="currentColor" strokeWidth="0.3" />
    <circle cx="4" cy="10" fill="currentColor" r="1.15" stroke="currentColor" strokeWidth="0.3" />
    <circle cx="4" cy="15" fill="currentColor" r="1.15" stroke="currentColor" strokeWidth="0.3" />
    <path d="M17 5H7" stroke="currentColor" strokeWidth="1.5" />
    <path d="M17 10H7" stroke="currentColor" strokeWidth="1.5" />
    <path d="M17 15H7" stroke="currentColor" strokeWidth="1.5" />
  </svg>
)
